
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutsDaCTHH94DSuH5cQgtkOFcOywxsSH_450B8jGwhZWaZXYMeta } from "/opt/render/project/src/frontend/pages/about.vue?macro=true";
import { default as indexDMFHK2twlriX5YDyOZwfHP0c1dlADgLqD4G3qm_9iYwMeta } from "/opt/render/project/src/frontend/pages/index.vue?macro=true";
import { default as photoR7RTaKOpmntoy_OW9S0F87o4der4TmJuRUEu6ClE0sYMeta } from "/opt/render/project/src/frontend/pages/photo.vue?macro=true";
import { default as videoywiJG3T8WhvZV1YWxAHvWH6_45mLsHaQsMsX5EYXVd_45mIMeta } from "/opt/render/project/src/frontend/pages/video.vue?macro=true";
import { default as index8cKOvuuHPE_uCeOAqjLxv_Eju_DF_45VDyQO6DWuhaCcUMeta } from "/opt/render/project/src/frontend/pages/blog/index.vue?macro=true";
import { default as indexus6ArzteugjywJPfaSBwWKKfr7jxKdpaHtJ29Bg8M4QMeta } from "/opt/render/project/src/frontend/pages/legal/index.vue?macro=true";
import { default as _91_46_46_46slug_93dH4uAEvaEUu3kRN3aYmSeKYZBHD85_45FLtnBGOlPQd78Meta } from "/opt/render/project/src/frontend/pages/blog/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93Ui66pzvHO3Tg_451ycVqlX7AVGbVZRdConi6wnwal0k0AMeta } from "/opt/render/project/src/frontend/pages/legal/[...slug].vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/render/project/src/frontend/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/render/project/src/frontend/pages/index.vue")
  },
  {
    name: "photo",
    path: "/photo",
    component: () => import("/opt/render/project/src/frontend/pages/photo.vue")
  },
  {
    name: "video",
    path: "/video",
    component: () => import("/opt/render/project/src/frontend/pages/video.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/opt/render/project/src/frontend/pages/blog/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/opt/render/project/src/frontend/pages/legal/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    component: () => import("/opt/render/project/src/frontend/pages/blog/[...slug].vue")
  },
  {
    name: "legal-slug",
    path: "/legal/:slug(.*)*",
    component: () => import("/opt/render/project/src/frontend/pages/legal/[...slug].vue")
  }
]